import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        console.log('[SW] Registrado:', reg.scope);
        // Token sync for background-sync auth
        const token = localStorage.getItem('token');
        if (token && reg.active) {
          reg.active.postMessage({ type: 'SET_TOKEN', token });
        }
      })
      .catch(err => console.warn('[SW] Registro fallido:', err));
  });
}

reportWebVitals();
